/**
 * 解析 FILE 字段或 OSS 路径，供 GET /merchant/oss/public/downloadurl 使用。
 * fieldValue 约定：可选「显示名|/mobile/upload/.../hash.ext」或纯路径/完整 URL。
 * filename 取 OSS 路径最后一段（如 ec7c8df990c41c4bcf70bb25b9cb4ef4.qt），与接口文档一致。
 */
export function resolveOssPublicDownloadParams(raw) {
  let s = String(raw == null ? '' : raw).trim()
  if (!s) {
    return { path: '', filename: '' }
  }

  const pipeIdx = s.indexOf('|')
  if (pipeIdx >= 0) {
    s = s.slice(pipeIdx + 1).trim()
  }

  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s.split('?')[0])
      s = u.pathname || s
    } catch (e) {
      s = s.split('?')[0].trim()
    }
  } else {
    s = s.split('?')[0].trim()
  }

  if (!s) {
    return { path: '', filename: '' }
  }

  const path = s.startsWith('/') ? s : `/${s}`
  const filename = path.split('/').filter(Boolean).pop() || ''

  return { path, filename }
}



// WEBPACK FOOTER //
// ./src/libs/utils/oss-public-file.js